// RecipeAudioPlayer — minimal audio chrome for the recipe intro.
//
// Renders nothing when no intro audio exists. When audio.intro.url is
// present (admin generated narration via the generate-recipe-narration
// edge function), shows a small play affordance + the native browser
// audio scrubber on tap.
//
// Lives on RecipePage above the ingredients body. CookMode handles
// per-step audio separately because step audio benefits from
// auto-play and step-aware behavior the intro doesn't need.

import { useEffect, useRef, useState } from "react";
import { FONT } from "../lib/tokens";

export default function RecipeAudioPlayer({ audio }) {
  const url = audio?.intro?.url;
  const [open, setOpen] = useState(false);
  const audioRef = useRef(null);

  // Pause + reset when the recipe changes (different url) so the new
  // page doesn't auto-resume mid-narration of the previous recipe.
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setOpen(false);
  }, [url]);

  if (!url) return null;

  if (!open) {
    return (
      <button
        onClick={() => {
          setOpen(true);
          // Defer play() until the <audio> element has mounted.
          setTimeout(() => audioRef.current?.play().catch(() => {}), 0);
        }}
        style={{
          marginTop: 10,
          display: "inline-flex", alignItems: "center", gap: 8,
          padding: "8px 14px",
          background: "rgba(255,252,241,0.85)",
          border: "1px solid rgba(124,94,44,0.30)",
          borderRadius: 999,
          fontFamily: FONT.forma, fontSize: 11, fontWeight: 600,
          letterSpacing: "0.10em", textTransform: "uppercase",
          color: "#5C3F18",
          cursor: "pointer",
        }}
      >
        <span aria-hidden>▶</span>
        Listen
      </button>
    );
  }

  return (
    <div style={{ marginTop: 10 }}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio
        ref={audioRef}
        src={url}
        controls
        preload="metadata"
        style={{ width: "100%", maxWidth: 360 }}
      />
    </div>
  );
}
